/* eslint-disable no-console */
/* eslint-disable max-len */
import { CloseOutlined } from '@mui/icons-material';
import SearchIcon from '@mui/icons-material/Search';
import { Avatar, Dialog, DialogContent, DialogTitle, Grid, IconButton, InputAdornment, Stack, TextField, Typography } from '@mui/material';
import React, { useContext, useEffect, useState } from 'react';
import Meetings from '../../../../assets/NoDataImages/NoMeetings.svg';
import Loading from '../../../../components/Common/Loaders/FullWidthLoader/Loading';
import NoData from '../../../../components/Common/NoData';
import { LanguageContext } from '../../../../libs/Context';
import { getSpeakersList } from '../../../actions/meeting_actions';
import useDebounce from '../../../../components/Hooks/useDebounce';
import useDidMountEffect from '../../../../libs/CustomHooks/UseDidMountEffect';
import MainCard from '../../../../UiComponents/Cards/MainCard';
import GroupUserSvgIcon from '../../../../assets/SvgIcons/GroupUserSvgIcon';

interface IQueryParams {
	skip?: number;
	limit?: number;
	count?: number;
	type?: string;
	id?: string;
	sessionId?: string;
	search?: string;
}
interface IAttendeeType
{
	count?: number;
	pageSkip?: number;
	itemsPerPage?: number;
	userList: object[];
	// speakerData: iSpeaker[];
	// shareWith: iAttendee[];
	loading: boolean;
	scrollLoading: boolean;
	relations:any
}
// meetingData
// list
// requestId
const AttendeesList = (props) =>
{
	const { handleAttendeesClose, attendees, requestType, requestId, list = [], meetingData, isSpeaker } = props;
	const { language } = useContext(LanguageContext);
	const [ searchVal, setSearchVal ] = useState<string>('');
	const [ attendesList, setAttendesList ] = useState<IAttendeeType>({
		count         : 0,
		pageSkip      : 0,
		itemsPerPage  : 10,
		userList      : list?.length > 0 ? list : [],
		relations     : [],
		loading       : Boolean(list?.length === 0 && meetingData?.metaData?.relations?.length === 0),
		scrollLoading : false
	});
	const { itemsPerPage, pageSkip, userList, relations,
		loading } = attendesList;
	const [ filteredData, setFilteredData ] = useState<IAttendeeType>(attendesList);
	const baseUrl = process.env.REACT_APP_S3_BASE_URL;
	const debouncedSearchTerm = useDebounce(searchVal, 500);

	// webinar
	const fetchSpeakersCount = async (query:any) =>
	{
		try
		{
			query.count = true;
			const res = await getSpeakersList(query);

			if (res?.status)
			{
				setAttendesList((prev) => ({ ...prev, count: res?.count }));
			}
		}
		catch (err)
		{
			setAttendesList((prev) => ({
				...prev,
				loading       : false,
				scrollLoading : false
			}));
			// eslint-disable-next-line no-console
			console.error('Error fetching count data:', err);
		}
	};

	const handleInitialLoad = (res, queryParams) =>
	{
		const isCountRequired = res?.data?.length >= 10;
		const updateRelation = meetingData?.metaData?.relations || meetingData?.relations || [];
		const listData = meetingData?.metaData?.externalMembers || meetingData?.shareWith || [];

		const updatedState = {
			loading       : false,
			scrollLoading : false,
			userList      : [ ...(res?.data ?? []), ...listData ],
			relations     : updateRelation,
			count         : res?.data?.length
		};

		if (isCountRequired)
		{
			fetchSpeakersCount(queryParams);
		}

		setAttendesList((prev) => ({
			...prev,
			...updatedState
		}));
	};

	const handlePagination = (res) =>
	{
		const newRes = res?.data?.length > 0 ? res?.data : [];
		const newArr = [ ...userList, ...newRes ];

		setAttendesList((prev) => ({
			...prev,
			loading       : false,
			scrollLoading : false,
			userList      : newArr
		}));
	};

	const fetchSpeakerRecords = async () =>
	{
		const isInitialLoad = pageSkip === 0;

		if (isInitialLoad)
		{
			setAttendesList((prev) => ({
				...prev,
				loading : true
			}));
		}

		const queryParams: IQueryParams = {
			sessionId : requestId,
			limit     : itemsPerPage || 10,
			skip      : pageSkip || 0
		};

		try
		{
			const res = await getSpeakersList(queryParams);

			if (!res?.status) return;

			if (isInitialLoad)
			{
				handleInitialLoad(res, queryParams);
			}
			else
			{
				handlePagination(res);
			}
		}
		catch (err)
		{
			setAttendesList((prev) => ({
				...prev,
				loading : false
			}));
			console.error('Error fetching webinar data:', err);
		}
	};
	// Incoming Request...

	useEffect(() =>
	{
		if (requestType === 'webinar' && list?.length <= 0)
		{
			fetchSpeakerRecords();
		}
		else if (requestType === 'webinar' && list?.length > 0)
		{
			const updateRelation = meetingData?.hasOwnProperty('metaData') ? meetingData?.metaData?.relations : meetingData?.relations;

			const listData = meetingData?.hasOwnProperty('metaData') ? meetingData?.metaData?.externalMembers : meetingData?.shareWith;

			setAttendesList((prev) => ({
				...prev,
				loading   : false,
				relations : updateRelation,
				userList  : pageSkip === 0 ? listData : [ ...prev.userList, ...listData ]
			}));
		}
		// else if (requestType === 'schedule')
		// {
		// 	fetchAttendesRecords();
		// }
		else
		{
			console.log('Oops! Check your request type...');
		}
	}, [ requestType ]);

	// Search Action...
	useDidMountEffect(() =>
	{
		const lowerCaseSearchVal = debouncedSearchTerm?.toLowerCase();

		let filteredUserList = userList || [];
		let filteredRelations = relations || [];

		if (debouncedSearchTerm)
		{
			const searchMatch = (item: any) =>
				item?.speakerName?.toLowerCase().match(lowerCaseSearchVal) ||
				item?.name?.toLowerCase().match(lowerCaseSearchVal) ||
				item?.email?.toLowerCase().match(lowerCaseSearchVal);

			filteredUserList = userList?.filter(searchMatch);
			filteredRelations = relations?.filter(searchMatch);
		}

		// Update state with filtered data
		setFilteredData((prev) => ({
			...prev,
			userList  : filteredUserList,
			count     : filteredUserList.length,
			relations : filteredRelations,
			loading   : false
		}));
	}, [ debouncedSearchTerm, userList, requestType ]);

	const dataLoop:any = searchVal === '' ? userList : filteredData?.userList;
	const relatnData:any = searchVal === '' ? relations : filteredData?.relations;

	return (
		<Dialog open={attendees} fullWidth maxWidth={'sm'}>
			<DialogTitle>
				<Grid container>
					<Grid item xs={12}>
						<Stack direction='row' justifyContent='space-between' alignItems='center'>
							<Typography variant='h6'>{isSpeaker ? language?.speakers : language.attendees}</Typography>
							<IconButton onClick={handleAttendeesClose}>
								<CloseOutlined sx={{ cursor: 'pointer' }} />
							</IconButton>
						</Stack>
					</Grid>
				</Grid>
			</DialogTitle>
			<DialogContent>
				<Grid container direction={'column'}>
					<Grid item>
						<TextField
							size='small'
							variant='outlined'
							placeholder={language?.searchMembers}
							fullWidth
							value={searchVal}
							// disabled={searchVal === '' && dataLoop?.length === 0}
							onChange={(e) => setSearchVal(e.target.value.replace(/^\s+/, ''))}
							InputProps={{
								startAdornment : (
									<InputAdornment position='start'>
										<SearchIcon />
									</InputAdornment>
								)
							}}
						/>
					</Grid>
					<Grid item mt={1}>
						<MainCard>
							<Grid item sx={{ maxHeight: '300px', overflowY: 'auto' }} display={'flex'} flexDirection={'column'}>
								{loading && <Loading />}
								{relatnData?.length > 0 && relatnData?.map((each, index) => (
									<Stack key={`${each?.name}_${index}`} direction='row' spacing={1} mb={1}>
										<Avatar alt='img' sx={{ width: '38px', height: '38px' }}>
											<GroupUserSvgIcon/>
										</Avatar>
										<span >{each?.name}</span>
										{typeof each?.count === 'number' && <span >({each?.count})</span>}
									</Stack>
								))}
								{dataLoop?.length > 0 && dataLoop?.map((each:any) => (
									<Stack key={each?.userId} direction='row' alignItems='center' spacing={1} mb={1}>
										<Avatar
											src={each?.userId ? `${baseUrl}/profile/${each?.userId}_profile.jpeg` : '/images/icons/defaultUser.svg'}
											sx={{ width: '38px', height: '38px' }}
										/>
										<Stack display={'flex'} flexDirection={'column'} pl='var(--pixel8)'>
											<Typography display='flex'>{each?.speakerName ?? each?.name ?? each?.email ?? language?.nA}</Typography>
											{each?.designation && <Typography fontSize={'var(--pixel12)'} color={'gray'}>
												{each?.designation}
											</Typography>}
										</Stack>
										{/* <span >{each?.speakerName ?? each?.name ?? each?.email ?? 'NA'}</span> */}
									</Stack>
								))}
								{!loading && relatnData?.length === 0 && dataLoop?.length === 0 &&
								<NoData noDataHead={isSpeaker ? language?.noSpeakerFound : language?.noAttendeesFound} color='lightTxt'
									src={<img src={Meetings} alt='noData'/>
									}
								/>}
							</Grid>
						</MainCard>
					</Grid>
				</Grid>
			</DialogContent>
		</Dialog>
	);
};

export default AttendeesList;
